import { z } from 'zod';

const Base = z.object({
  token: z.string(),
  marketing_opt: z.enum(['1']),
  email: z.string().email(),
  form_name: z.string(),
  page_url: z.string().url()
});

type Newsletter = z.infer<typeof Base>;

export { Base, type Newsletter };
